<template>
  <cTable
    ref="table"
    :fields="fields"
    :modals="modals"
    :header="header"
    :methods="methods"
  >
  </cTable>
</template>

<script>
import {
  add,
  getConvert,
  getDetails,
  update,
  del
} from "@/api/tracker/convert";
import { getCity } from "@/api/system/city";
import { getAgent } from "@/api/tracker/agent";
import cTable from "@/base/common/index";
export default {
  name: "convert",
  components: {
    cTable
  },

  async mounted() {},
  methods: {},
  data() {
    return {
      methods: {
        list: getConvert,
        add,
        getDetails,
        update,
        del,
        getCity,
        getAgent
      },
      modals: {
        add: {
          methods: {
            ok({ row, close }) {
              this.$page
                .handleRequestMethods(row.id ? "update" : "add", row, true)
                .then(e => {
                  this.$page.getList();
                  close();
                });
            }
          },
          footer: {
            ok: {},
            cancel: {}
          },
          config: {
            modalBind: {
              width: "40%"
            },
            formBind: {
              labelWidth: 150
            },
            rowBind: {
              gutter: 13,
              style: {
                marginBottom: "20px"
              }
            },
            rules: {
              city_mapping: [
                {
                  required: true,
                  type: "string",
                  message: "mapping cannot be empty",
                  trigger: "blur"
                },
                {
                  max: 155,
                  message: "Maximum length 55",
                  trigger: "blur"
                }
              ],
              agent_id: [
                {
                  required: true,
                  type: "number",
                  message: "agent cannot be empty",
                  trigger: "change"
                }
              ],
              city_id: [
                {
                  required: true,
                  type: "number",
                  message: "city cannot be empty",
                  trigger: "change"
                }
              ]
            }
          },
          grid: [{ city_mapping: 24 }, { agent_id: 24 }, { city_id: 24 }],
          fields: [
            {
              key: "city_mapping",
              name: () => this.$t("city_mapping"),
              component: "Input",
              placeholder() {
                return this.$t("enter") + this.$t("city_mapping");
              }
            },
            {
              key: "agent_id",
              name: () => this.$t("agentName"),
              component: "Select",
              config: {
                label: "agent_name",
                value: "id"
              },
              placeholder() {
                return this.$t("select") + this.$t("agentName");
              },
              options: [],
              methods: {
                async list({ field }) {
                  field.options = (
                    await this.$page.handleRequestMethods("getAgent")
                  ).payload.rows;
                  this.$forceUpdate();
                }
              }
            },
            {
              key: "city_id",
              name: () => this.$t("city_name"),
              component: "Select",
              config: {
                label: "title",
                value: "id"
              },
              placeholder() {
                return this.$t("select") + this.$t("city_name");
              },
              options: [],
              methods: {
                async list({ field }) {
                  field.options = (
                    await this.$page.handleRequestMethods("getCity")
                  ).payload.rows;
                  this.$forceUpdate();
                }
              }
            }
          ]
        }
      },
      header: {
        searchs: [
          {
            key: "keywords",
            placeholder() {
              return this.$t("keyword");
            },
            bind: {
              type: "textarea",
              rows: 1
            },
            component: "Input"
          }
        ],
        btns: {
          list: [
            {
              name: () => this.$t("add"),
              type: "add",
              fnName: "addFun",
              bind: {
                type: "warning",
                icon: "md-add"
              },
              id: 183
            }
          ],
          methods: {
            addFun({ field, searchForm }) {
              this.getModal("add").open({}, function() {
                this.setTitle(this.$t("add"));
              });
            }
          }
        }
      },
      fields: [
        {
          name: () => this.$t("city_mapping"),
          key: "city_mapping",
          align: "left",
          minWidth: 200
        },
        {
          name: () => this.$t("agentName"),
          key: "agent_name",
          align: "left",
          minWidth: 200,
          methods: {
            render({ row }) {
              return row.agent ? row.agent.agent_name : "/";
            }
          }
        },
        {
          name: () => this.$t("city_name"),
          key: "city_name",
          align: "center",
          minWidth: 200,
          methods: {
            render({ row }) {
              return row.city ? row.city.title : "/";
            }
          }
        },
        {
          type: "btns",
          width: 200,
          name: () => this.$t("operation"),
          fixed: "right",
          list: [
            {
              name: () => this.$t("update"),
              type: "update",
              fnName: "updateFun",
              bind: {
                type: "success"
              },
              id: 184
            },
            {
              name: () => this.$t("delete"),
              type: "delete",
              fnName: "deleteFun",
              bind: {
                type: "error"
              },
              id: 185
            }
          ],

          methods: {
            async updateFun({ row }) {
              console.log(row);
              let res = await this.handleRequestMethods("getDetails", {
                id: row.id
              });
              console.log("res", res);

              this.getModal("add").open(res.payload, function() {
                this.setTitle(this.$t("update"));
              });
            },
            async operationFun({ row }) {
              this.getModal("operation").open(
                {
                  packageId: row.id
                },
                function() {
                  this.setTitle(this.$t("operation"));
                }
              );
            },
            deleteFun({ row }) {
              this.$Modal.confirm({
                title:
                  this.$t("whether") +
                  this.$t("confirm") +
                  this.$t("delete") +
                  this.$t("city_mapping") +
                  ":" +
                  row.city_mapping +
                  "?",
                onOk: () => {
                  this.handleRequestMethods(
                    "del",
                    {
                      id: row.id
                    },
                    true
                  ).then(res => {
                    // this.$Message.success(res.data.msg);
                    this.getList();
                  });
                }
              });
            }
          }
        }
      ]
    };
  }
};
</script>
<style type="text/css">
/* @page{
    size: 7cm 8cm;
  } */
.city-name {
  height: 34px;
  display: inline-block;
  line-height: 34px;
  margin: 5px;
  padding: 0 5px;
  border-radius: 4px;
  border: 1px solid #e8eaec;
}
.city-div :nth-child(3n + 1).city-name {
  color: #fff;
  background-color: #59c48e;
}
.city-div :nth-child(3n).city-name {
  color: #fff;
  background-color: #403868;
}
.city-div :nth-child(3n-1).city-name {
  color: #fff;
  background-color: #616664;
}
</style>
<style lang="scss" scoped></style>
